import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {
  deleteAccountNumber,
  IDeleteAccountNumberPayload,
} from './postAccountNumbers';

const useDeleteAccountNumber = (
  handleAfterSuccess?: (variables: IDeleteAccountNumberPayload) => void,
) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, mutateAsync, isSuccess} = useMutation({
    mutationFn: (payload: IDeleteAccountNumberPayload) =>
      deleteAccountNumber(payload),

    onSuccess: (_, variables) => {
      handleAfterSuccess?.(variables);
      queryClient.invalidateQueries(['get-user-account_numbers']);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, mutateAsync, isSuccess};
};

export default useDeleteAccountNumber;
